import { toast } from "react-toastify";
import { TrendingProducts } from "../../Services/MainServices";
import {
  FETCH_POPULAR_PRODUCTS_FAILURE,
  FETCH_POPULAR_PRODUCTS_REQUEST,
  FETCH_POPULAR_PRODUCTS_SUCCESS,
} from "../types/popularProductsTypes";

// Thunk Action
export const getTrendingProducts = () => async (dispatch) => {
  // console.log("Fetching trending products...");
  dispatch({ type: FETCH_POPULAR_PRODUCTS_REQUEST });

  try {
    // Make the API call
    const res = await TrendingProducts();
    // console.log("API Response:", res); // Log the entire response for debugging

    // Check if the response is valid
    if (res?.status === 200 && res?.data?.results?.length > 0) {
      const results = res.data.results || [];
      // console.log("Mapped Products Actions:", results); // Log the mapped products
      dispatch({
        type: FETCH_POPULAR_PRODUCTS_SUCCESS,
        payload: results,
      });
    } else {
      const msg = res?.data?.message || "No products found in the response.";
      // console.error("Error Message:", msg); // Log the error message
      dispatch({ type: FETCH_POPULAR_PRODUCTS_FAILURE, payload: msg });
      toast.error(msg); // Display error notification
    }
  } catch (error) {
    // console.error("Error during API call:", error); // Log the error
    const status = error?.response?.status;

    if (status === 401 || status === 403) {
      // Handle unauthorized or token expiration
      toast.error("Session expired. Please login again.");
    } else {
      const errorMsg = error?.response?.data?.message || "Something went wrong";
      // console.error("Detailed Error:", errorMsg); // Log detailed error message
      toast.error(errorMsg); // Display error notification
      dispatch({
        type: FETCH_POPULAR_PRODUCTS_FAILURE,
        payload: errorMsg,
      });
    }
  }
};
